import React, { useState, useEffect, createContext, useContext } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import Matches from './components/Matches';
import Ranking from './components/Ranking';
import MyPronos from './components/MyPronos';
import ForecastPage from './components/ForecastPage';

const API = process.env.REACT_APP_API_URL || '/api';
export const AuthContext = createContext(null);

function useAuth() { return useContext(AuthContext); }
export { useAuth };

function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const active = (p) => loc.pathname === p ? 'nav-btn active' : 'nav-btn';

  return (
    <nav className="navbar">
      <div className="navbar-logo" onClick={() => navigate('/')} style={{cursor:'pointer'}}>
        CDM <span>2026</span>
      </div>
      <div className="navbar-nav">
        <button className={active('/')} onClick={() => navigate('/')}>Matchs</button>
        <button className={active('/cotes')} onClick={() => navigate('/cotes')}>🔮 Cotes</button>
        <button className={active('/classement')} onClick={() => navigate('/classement')}>🏆 Classement</button>
        {user && <button className={active('/mes-pronos')} onClick={() => navigate('/mes-pronos')}>🎯 Mes pronos</button>}
        {user
          ? <button className="nav-btn" onClick={logout} style={{color:'var(--danger)'}}>Déconnexion</button>
          : <button className="nav-btn active" onClick={() => navigate('/login')} style={{background:'var(--accent)',color:'#080c14',fontWeight:600}}>Connexion</button>
        }
      </div>
    </nav>
  );
}

function Toast({ msg, type, onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, 3000);
    return () => clearTimeout(t);
  }, [onClose]);
  return <div className={`toast ${type}`}>{msg}</div>;
}

function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const BOT_NAME = process.env.REACT_APP_BOT_NAME || 'cdm2026sim_bot';

  useEffect(() => {
    window.onTelegramAuth = async (data) => {
      try {
        const res = await axios.post(`${API}/auth/telegram`, data);
        login(res.data.token, res.data.user);
        navigate('/');
      } catch {
        alert('Erreur authentification');
      }
    };
    // Injecter le script Telegram widget
    const script = document.createElement('script');
    script.src = 'https://telegram.org/js/telegram-widget.js?22';
    script.setAttribute('data-telegram-login', BOT_NAME);
    script.setAttribute('data-size', 'large');
    script.setAttribute('data-onauth', 'onTelegramAuth(user)');
    script.setAttribute('data-request-access', 'write');
    script.async = true;
    document.getElementById('tg-widget').appendChild(script);
    return () => { delete window.onTelegramAuth; };
  }, [login, navigate, BOT_NAME]);

  return (
    <div className="container">
      <div className="card login-card">
        <div className="login-icon">⚽</div>
        <div className="login-title">REJOINDRE</div>
        <p className="login-sub">
          Connectez-vous avec Telegram pour pronostiquer les matchs et rejoindre le classement.
        </p>
        <div id="tg-widget" style={{display:'flex',justifyContent:'center'}} />
        <p style={{marginTop:20,fontSize:12,color:'var(--muted)'}}>
          Vous pouvez aussi pronostiquer directement via<br/>
          <strong>@cdm2026sim_bot</strong> sur Telegram
        </p>
      </div>
    </div>
  );
}

export default function App() {
  const [user, setUser] = useState(() => {
    try {
      const t = localStorage.getItem('cdm_token');
      const u = localStorage.getItem('cdm_user');
      return t && u ? JSON.parse(u) : null;
    } catch { return null; }
  });
  const [toast, setToast] = useState(null);

  const login = (token, u) => {
    localStorage.setItem('cdm_token', token);
    localStorage.setItem('cdm_user', JSON.stringify(u));
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem('cdm_token');
    localStorage.removeItem('cdm_user');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
  };

  // Restaurer le token axios au chargement
  useEffect(() => {
    const t = localStorage.getItem('cdm_token');
    if (t) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${t}`;
    }
  }, []);

  // Intercepteur pour toujours ajouter le token frais
  useEffect(() => {
    const id = axios.interceptors.request.use(config => {
      const t = localStorage.getItem('cdm_token');
      if (t) config.headers['Authorization'] = `Bearer ${t}`;
      return config;
    });
    return () => axios.interceptors.request.eject(id);
  }, []);

  const showToast = (msg, type = 'success') => setToast({ msg, type });

  return (
    <AuthContext.Provider value={{ user, login, logout, showToast }}>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Matches />} />
          <Route path="/cotes" element={<ForecastPage />} />
          <Route path="/classement" element={<Ranking />} />
          <Route path="/mes-pronos" element={<MyPronos />} />
          <Route path="/login" element={<LoginPage />} />
        </Routes>
        {toast && <Toast msg={toast.msg} type={toast.type} onClose={() => setToast(null)} />}
      </BrowserRouter>
    </AuthContext.Provider>
  );
}
